import { render } from "./ProfesseursDetails.vue?vue&type=template&id=551ba594&ts=true"
import script from "./ProfesseursDetails.vue?vue&type=script&lang=ts"
export * from "./ProfesseursDetails.vue?vue&type=script&lang=ts"

import "./ProfesseursDetails.vue?vue&type=style&index=0&id=551ba594&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__